export default "__VITE_ASSET__Dt5SR6ty__"